let idCtr = 0

export default {
  stack: [],
  addNotification (notification) {
    this.stack.push({ id: idCtr++, ...notification })
  },
  removeNotification (notification) {
    const idx = this.stack.findIndex(n => n.id === notification.id)
    this.stack.splice(idx, 1)
  }
}
